import { render, staticRenderFns } from "./ShippingMethod.vue?vue&type=template&id=841a383a&"
import script from "./ShippingMethod.js?vue&type=script&lang=js&"
export * from "./ShippingMethod.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ShippingMethod.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fcheckout%2FShippingMethod%2FShippingMethod.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports